module.exports = __webpack_public_path__ + "img/organization2.90c4e229.png";